import React from 'react'
import { formatDate } from '../utils/dateUtils'

const PhotoExif = ({ photo, t }) => {
  const megapixels =
    photo.width && photo.height
      ? `${((photo.width * photo.height) / 1_000_000).toFixed(0)} ${t(
          'MEGAPIXELS',
        )}`
      : null

  const dpi = 300
  const cmWidth = photo.width ? ((photo.width / dpi) * 2.54).toFixed(0) : null
  const cmHeight = photo.height
    ? ((photo.height / dpi) * 2.54).toFixed(0)
    : null

  const entries = [
    {
      label: t('PHOTO_RESOLUTION'),
      value:
        photo.width && photo.height ? `${photo.width}x${photo.height}` : null,
    },
    { label: t('PHOTO_DEFINITION'), value: megapixels },
    /*{
      label: t('MAX_PRINT_SIZE'),
      value: cmWidth && cmHeight ? `${cmWidth} x ${cmHeight} cm` : null
    },*/
    { label: t('FOCAL_LENGTH'), value: photo.focalLength },
    { label: t('APERTURE'), value: photo.aperture },
    { label: t('SHUTTER_SPEED'), value: photo.shutterSpeed },
    { label: t('ISO'), value: photo.iso },
    // { label: t('MANUFACTURER'), value: photo.manufacturer }, // optionnel
    { label: t('CAMERA_MODEL'), value: photo.cameraModel },
    { label: t('LENS_MAKE'), value: photo.lensMake },
    {
      label: t('PHOTO_CAPTURED_AT'),
      value: photo.capturedAt ? formatDate(photo.capturedAt, true) : null,
    },
    {
      label: t('PHOTO_CAPTURED_BY'),
      value:
        photo.capturedBy?.firstname && photo.capturedBy?.lastname
          ? `${photo.capturedBy.firstname} ${photo.capturedBy.lastname}`
          : null,
    },
    // { label: t('ALTITUDE'), value: photo.altitude }, // Uncomment if needed
  ].filter((entry) => entry.value) // ⚠️ Ne garde que les entrées avec une valeur définie

  return (
    <div className="summary-box text-start">
      <dl className="row">
        {entries.map((entry, idx) => (
          <div key={idx} className="col-12 col-sm-6 mb-3">
            <dl className="row mb-0">
              <dt className="col-5 mb-0">{entry.label}:</dt>
              <dd className="col-7 mb-0">{entry.value}</dd>
            </dl>
          </div>
        ))}
      </dl>
    </div>
  )
}

export default PhotoExif
